import loadable from "@loadable/component";

const Support = loadable(() => import("./Support.page"));

export default { component: Support };
